import { render, staticRenderFns } from "./reccostmanage.vue?vue&type=template&id=2d05e1e6&scoped=true&"
import script from "./reccostmanage.vue?vue&type=script&lang=js&"
export * from "./reccostmanage.vue?vue&type=script&lang=js&"
import style0 from "./reccostmanage.vue?vue&type=style&index=0&id=2d05e1e6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d05e1e6",
  null
  
)

export default component.exports